<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Important" />
            <ImportantDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ImportantDevices from '../Important/ImportantDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ImportantPage',
    components: {
        MainHeader,
        PageTitle,
        ImportantDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>